/** Manual repair reports what was saved, not a guarantee of visual quality. */
export interface BandRepairResult {
  generatedAdId: string;
  durableUrl: string;
  outpainted: boolean;
  bandSource: "outpainted" | "failure_fallback" | "qa_downgraded";
  bandAttempts: number;
}

export function bandRepairNotice(result: BandRepairResult) {
  if (result.outpainted && result.bandSource === "outpainted") {
    return {
      title: "Bands regenerated",
      description: "New generated bands were saved. The ad's center is unchanged; review the result.",
    };
  }
  return {
    title: "Fallback bands saved",
    description: result.bandSource === "qa_downgraded"
      ? "Generated bands did not pass the band check, so local color-fill bands were saved instead. The ad's center is unchanged."
      : "Band generation was unavailable, so local color-fill bands were saved instead. The ad's center is unchanged.",
  };
}
